import { Concept } from '@/constants/scenarios';
import { getTransferPair } from '@/services/transferPairs';
import { TransferPair } from '@/types/transfer-pair';
import { useEffect, useState } from 'react';

export function useTransferPair({
  concept,
  customerId,
  vendorId,
  invoicingCurrency,
}: {
  concept: Concept | undefined;
  customerId: string | undefined;
  vendorId: string | undefined;
  invoicingCurrency: string;
}) {
  const [data, setData] = useState<TransferPair | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    if (!customerId || !vendorId || !concept) {
      setData(null);
      setLoading(false);
      return;
    }
    getTransferPair({ customerId, vendorId, concept, invoicingCurrency })
      .then(res => active && setData(res))
      .catch(err => active && setError(err?.message ?? 'Unknown error'))
      .finally(() => active && setLoading(false));

    return () => {
      active = false;
    };
  }, [customerId, vendorId, concept, invoicingCurrency]);

  return { data, loading, error };
}
